export const AFTER_LOGIN_PATH = "/afterlogin";
export const AUTHENTICATED_HOME_PATH = "/yearsdashboard";

const EMPTY_PROFILE_VALUES = new Set(["", "null", "none", "undefined", "nan"]);

export const normalizeProfileValue = (value) => {
  if (value == null) return "";

  const normalized = String(value).trim();
  if (!normalized) return "";

  return EMPTY_PROFILE_VALUES.has(normalized.toLowerCase()) ? "" : normalized;
};

export const normalizeDateOfBirth = (value) => {
  const normalized = normalizeProfileValue(value);
  if (!normalized) return "";

  const isoDateMatch = normalized.match(/^(\d{4}-\d{2}-\d{2})/);
  return isoDateMatch ? isoDateMatch[1] : "";
};

export const normalizeProfilePhoto = (value) => {
  const normalized = normalizeProfileValue(value);
  if (!normalized) return "";

  return normalized === "1" ? "" : normalized;
};

export const getProfileCompletionState = (profile = {}) => {
  const normalizedUserName = normalizeProfileValue(profile.user_name);
  const normalizedDob = normalizeDateOfBirth(profile.parents_date_of_birth);
  const normalizedAvatar = normalizeProfilePhoto(profile.profilephotos);

  return {
    normalizedUserName,
    normalizedDob,
    normalizedAvatar,
    isNameMissing: !normalizedUserName,
    isDobMissing: false,
    isAvatarMissing: !normalizedAvatar,
  };
};

export const getAfterLoginInitialStep = (profile = {}) => {
  const { isNameMissing } = getProfileCompletionState(profile);

  if (isNameMissing) return 1;
  return 2;
};

export const isProfileIncomplete = (profile = {}) => {
  const { isNameMissing, isAvatarMissing } = getProfileCompletionState(profile);

  return isNameMissing || isAvatarMissing;
};

export const getAuthenticatedRedirectPath = (profile = {}) =>
  isProfileIncomplete(profile) ? AFTER_LOGIN_PATH : AUTHENTICATED_HOME_PATH;
